import useAppDispatch from 'hooks/useAppDispatch';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import paramsActions from 'store/actions/params.actions';

const Teachers: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(
        paramsActions.initializeParams('teachersParams', {
          $limit: 20,
        }),
      );
      dispatch(
        paramsActions.initializeParams('teacherApplicationsParams', {
          $limit: 6,
          $populate: ['vacancy', 'schools'],
        }),
      );
    };
  }, [dispatch]);

  return <Outlet />;
};

export default Teachers;
